export default "__VITE_ASSET__ChW3I3tU__"